import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { Form, Button, Modal, Alert, CloseButton } from "react-bootstrap";
import '../styles/Login.css';

export default function Login({ setLoggedIn }) {
    useEffect(() => {
        document.title = "DocuQuest Login"; // Set the tab name
    }, []);

    const navigate = useNavigate();
    const [input_data, setInputs] = useState({});
    const [showTrackingModal, setShowTrackingModal] = useState(false);  
    const [trackingNumber, setTrackingNumber] = useState('');
    const [trackingName, setTrackingName] = useState('');
    const [errorMessage, setErrorMessage] = useState(""); // State for error messages

    const attempt_tracking = (e) => {
        e.preventDefault();

        axios.post('https://docuquest-swu.swucite.tech/api_drts/transactionsOwner.php/', {trackingNumber: trackingNumber, trackingName: trackingName})
        .then((res)=>{
            const found_request = res.data;
            navigate(`/tracking/${found_request.reference_number}`);
            setShowTrackingModal(false)
        })
        .catch((err)=>{
            alert("Cannot find request ", trackingName);
            //console.error("ERROR tracking request. REASON:", err);
        })        

        // setTrackingName('');
        // setTrackingNumber('');
    }

    const attempt_login = (event) => {
        event.preventDefault();
        
        const plainPass = input_data.txt_pass; 
        
        /* attempt logging in as staff */
        axios.post('https://docuquest-swu.swucite.tech/api_drts/loginUser.php', {
            // data
            email: input_data.txt_email,
            password: plainPass
        },
        {
            withCredentials: true
        })
        .then((responseUser) => {
            if(responseUser.data.status === 1){
                // sessionStorage.setItem("name_user", responseUser.data.name);
                // sessionStorage.setItem("id_user", responseUser.data.id);
                // sessionStorage.setItem("role_user", responseUser.data.role);

                setLoggedIn(true);
                navigate('/*');
            } else {
                //console.warn(responseUser.data.message)
                setErrorMessage(`Login failed: ${responseUser.data.message}`, );
                // setErrorMessage(responseUser.data.message || "Staff login failed. Trying client login...");

                // /* attempt logging in as client */
                // axios.post('https://docuquest-swu.swucite.tech/api_drts/loginClient.php', {
                //     email: input_data.txt_email,
                //     password: plainPass                    
                // },
                // {
                //     withCredentials: true
                // })
                // .then((responseClient)=>{
                //     if(responseClient.data.status === 1){
                //         sessionStorage.setItem("name_user", responseClient.data.name);
                //         sessionStorage.setItem("id_user", responseClient.data.id);
                //         sessionStorage.setItem("id_swu", responseClient.data.id_swu);
                //         navigate('/manage/requests');
                //     } else {
                //         console.warn("Login client response failed: ", responseClient.data.message);
                //         setErrorMessage(responseClient.data.message || "Client login failed. Please try again.");
                //     }        
                // })
                // .catch((err)=>{
                //     console.error("ERROR LOGIN CLIENT: ", err);
                //     setErrorMessage("An error occurred while logging in as a client.");
                // });
            }
        })
        .catch((err) => {
            setErrorMessage(`ERROR LOGIN STAFF: ${err}`);

        });
    };
    
    const changeValues = (event) => {
        const { name, value } = event.target;
        setInputs(oldInputs => ({
            ...oldInputs,
            [name] : value
        }));
    };
    
    const changeTrackingNumber = (event) => {
        const { value } = event.target;
        setTrackingNumber(`REF-${value}`);
    };

    const changeTrackingName = (event) => {
        const { value } = event.target;
        setTrackingName(value);
    };

    // only pass state if input_data.txt_email is not null
    const state_email = input_data.txt_email ? { email: input_data.txt_email } : null;

    return (
        <div className='app-wrapper'>
            <div className='Login'>
                <section id='title'>
                    <h2>DocuQuest</h2>
                    <h1>Document Requesting and Tracking System</h1>
                </section>
                <section id="form-login">
                    {errorMessage && (
                        <Alert variant="danger">
                            {errorMessage}
                        </Alert>
                    )}
                    <form onSubmit={attempt_login}> 
                        <label htmlFor="txt_email">Email Address</label>
                        <input required name="txt_email" type="email" onChange={changeValues} placeholder="jooe.swu@phinmaed.com"/>
                        
                        <label htmlFor="txt_pass">Password</label>

                        <div className="password-wrapper">
                            <input required name="txt_pass" type="password" onChange={changeValues} placeholder="abcdefgh123456/@#!?"/>
                            <Link to="/forgot/find" state={state_email}>
                                <p className='link_forgot' title='Forgot your password?'>Forgot&nbsp;your&nbsp;password?</p>
                            </Link>
                        </div>

                        <input type="submit" value="Login" title="Login as staff"/>
                    </form>
                </section>
                <section>
                    <button id='request' onClick={() => navigate('/start', {replace: true})} title='Go back to starting page'>
                        Back
                    </button>
                </section>
                {/* navigate(-1) */}
                {/* <section id="actions-request">
                    <button id='request' onClick={() => navigate('/request')} title='Request for a document'>
                        Make a Request
                    </button>
                    <button id='tracking' onClick={() => setShowTrackingModal(true)} title='Track down a document request'>
                        Request Tracking
                    </button>

                    <Modal centered show={showTrackingModal} onHide={() => setShowTrackingModal(false)} backdrop={true}>
                      <Modal.Header>
                        <Modal.Title>Track a Request</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <form onSubmit={attempt_tracking}>
                          <div className="referencenumber-wrapper">
                            <p>REF-</p>
                            <input
                            required
                            type="tel"
                            name="trackingNumber"
                            className='' // TODO
                            pattern="[0-9]{13}-[0-9]{6}"
                            minLength={20}
                            maxLength={20}
                            onChange={changeTrackingNumber}
                            />
                            </div>

                            <input
                            required
                            type="text"
                            name="trackingName"
                            className=''
                            placeholder="Enter last name of owner"
                            onChange={changeTrackingName}
                            />
                          <button className=''>
                           Track
                          </button>
                        </form>
                      </Modal.Body>
                    </Modal>
                </section> */}
            </div> 
        </div>
    );
}
